import {
  create,
  parseCreationOptionsFromJSON,
  supported,
} from "@github/webauthn-json/browser-ponyfill";
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="webauthn"
export default class extends Controller {
  static targets = ["keymatterInput", "browserSupportWarning", "form"];
  static values = {
    apiEndpoint: String,
    errorContainerSelector: String,
    keymatterInputSelector: String,
  };

  static get shouldLoad() {
    return supported();
  }

  connect() {
    this.browserSupportWarningTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");
  }

  async createCredential(event) {
    event.preventDefault();
    this.hideError();

    const json = await (await fetch(this.apiEndpointValue)).json();
    const options = parseCreationOptionsFromJSON({ publicKey: json });
    const maybeKeymatter = create(options);

    maybeKeymatter
      .then((keymatter) => {
        this.keymatterInputTarget.value = JSON.stringify(keymatter);
        this.formTarget.requestSubmit();
      })
      .catch((error) => {
        if (error.name === "InvalidStateError") {
          this.showError("Security key already added.");
        } else {
          this.showError(
            "Failed to add security key, an unexpected error occurred.",
          );
          console.error(error);
        }
      });
  }

  showError(message) {
    this.errorContainer.classList.remove("hidden");
    this.errorContainer.innerText = message;
  }

  hideError() {
    this.errorContainer.classList.add("hidden");
  }

  get errorContainer() {
    return document.querySelector(this.errorContainerSelectorValue);
  }
}
